import React, { Component } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import ConfiguratorSection from '../ConfiguratorSection';
import ConfiguratorImage from '../ConfiguratorImage';
import ConfiguratorOption from '../ConfiguratorOption';
import MaterialSelector from '../MaterialSelector';
import Disclaimer from '../Disclaimer';
import { galleyImageOptions } from './views/galley'

class Galley extends Component {
    constructor(props) {
		super(props);
		this.handleGalleyChange = this.handleGalleyChange.bind(this);
    }

	handleGalleyChange(newValue) {
		let configuration = this.props.configuration;
		configuration.Worktop = newValue;

		if (this.props.onChange) {
			this.props.onChange(configuration);
		}
	}
    render() {
		let imageOptions = galleyImageOptions;

        let image = (
            <ConfiguratorImage boat="X4_3MK2" configuration={this.props.configuration} options={imageOptions} />
        );


        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{position:'relative'}}>


					<h1><Trans defaults='GALLEY' /></h1>

					<MaterialSelector label={this.props.configuration.Worktop.label} options={this.props.worktopOptions} value={this.props.configuration.Worktop} onChange={this.handleGalleyChange} />


                    <Disclaimer />
                   

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(Galley);


// WEBPACK FOOTER //
// ./src/X43MK2/Galley.js